import React, { lazy } from 'react';
import { Quote } from 'lucide-react';
const TESTIMONIALS = [{
  quote: 'Es la primera vez que me calmo sin luchar.',
  author: 'Claudia',
  age: '34 años',
  location: 'CDMX',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop&crop=face'
}, {
  quote: 'No sabía que mi cuerpo podía soltar tan rápido.',
  author: 'María',
  age: '42 años',
  location: 'Sevilla',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face'
}, {
  quote: 'Ahora sé que no estoy rota.',
  author: 'Lucía',
  age: '29 años',
  location: 'Buenos Aires',
  avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop&crop=face'
}, {
  quote: 'Me devuelve la calma sin esfuerzo.',
  author: 'Andrea',
  age: '37 años',
  location: 'Bogotá',
  avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=face'
}];
export function TestimonialsSection() {
  return <section className="py-20 bg-[#C06B6B] px-4" data-id="element-278">
      <div className="max-w-6xl mx-auto" data-id="element-279">
        <div className="text-center mb-16" data-id="element-280">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-281">
            🌍 Hoy, miles de mujeres ya sienten esto
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-282">
          {TESTIMONIALS.map((t, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-lg hover:-translate-y-1 transition-transform duration-300" data-id="element-283">
              <div className="flex items-center gap-3 mb-4" data-id="element-284">
                <img src={t.avatar} alt={t.author} className="w-12 h-12 rounded-full object-cover ring-2 ring-[#C4973B]/30" loading="lazy" data-id="element-285" />
                <Quote className="h-6 w-6 text-[#C4973B] opacity-50 ml-auto" data-id="element-286" />
              </div>
              <p className="text-gray-800 font-medium mb-6 min-h-[3rem]" data-id="element-287">
                "{t.quote}"
              </p>
              <div className="border-t border-gray-100 pt-4" data-id="element-288">
                <p className="font-bold text-gray-900" data-id="element-289">
                  {t.author}, {t.age}
                </p>
                <p className="text-sm text-gray-500" data-id="element-290">{t.location}</p>
              </div>
            </div>)}
        </div>

        <div className="text-center mt-12 text-white/90 font-medium text-lg" data-id="element-291">
          <p data-id="element-292">
            En minutos, el cuerpo responde. En días, deja de reaccionar igual.{' '}
            <br data-id="element-293" />
            En semanas, la mente ya no vive en guerra.
          </p>
        </div>
      </div>
    </section>;
}